import React, { type PropsWithChildren, createContext, useState, useEffect, useMemo } from "react";

interface TabContext {
  activeTab?: string | number;
  setActiveTab?: (value: string | number) => void;
}

interface TabContextProps extends PropsWithChildren {
  value?: string | number;
}

export const TabContext = createContext<TabContext>({});

export function SupTabContext({ value, children }: TabContextProps) {
  const [activeTab, setActiveTab] = useState(value);

  useEffect(() => {
    setActiveTab(value);
  }, [value]);

  const contextValue = useMemo(() => ({ activeTab, setActiveTab }), [activeTab, setActiveTab]);

  return <TabContext.Provider value={contextValue}>{children}</TabContext.Provider>;
}
